import { AssetHardwareType } from "TypeGen/Assets/asset-hardware-type";

export const vehicleHardwareTypes = [
  { ID: AssetHardwareType.Netradyne, Name: 'Netradyne' },
  { ID: AssetHardwareType.Omnitracs, Name: 'Omnitracs' },
  { ID: AssetHardwareType.MichiganLicensePlate, Name: 'Michigan License Plate' },
  { ID: AssetHardwareType.BestPass, Name: 'Best Pass' },
  { ID: AssetHardwareType.FuelCard, Name: 'Fuel Card' },
  { ID: AssetHardwareType.BridgeTag, Name: 'Bridge Tag' },
  { ID: AssetHardwareType.LeadCard, Name: 'Lead Card' },
  { ID: AssetHardwareType.Transponder, Name: 'Transponder' },
  { ID: AssetHardwareType.NameBadge, Name: 'Name Badge' },
  { ID: AssetHardwareType.TriStateSamsara, Name: 'Samsara (Tri-State)' },
  { ID: AssetHardwareType.LoadOneSamsara, Name: 'Samsara Gateway' },
  { ID: AssetHardwareType.DecalsDoorsOnly, Name: 'Decals: Doors Only' },
  { ID: AssetHardwareType.DecalsFullWrap, Name: 'Decals: Full Wrap' },
  { ID: AssetHardwareType.IFTANYHUTSticker, Name: 'IFTA & NY HUT Sticker' },
  { ID: AssetHardwareType.PermitBinder, Name: 'Permit Binder' },
  { ID: AssetHardwareType.SamsaraCamera, Name: 'Samsara Camera' },
  { ID: AssetHardwareType.SamsaraGatewayCord, Name: 'Samsara Gateway Cord' },
];

const hiddenVehicleHardwareTypes = [
  AssetHardwareType.Netradyne,
  AssetHardwareType.Omnitracs,
  AssetHardwareType.TriStateSamsara,
];

export const assignableVehicleHardwareTypes = (currentType: AssetHardwareType | null) =>
  vehicleHardwareTypes.filter(x => !hiddenVehicleHardwareTypes.includes(x.ID) || x.ID === currentType);
